import React, { useEffect, useState } from "react";
import { getCurrentUser } from "../../auth";
import { getSISSettings, setSISSettings, getActiveSchoolYear, setActiveSchoolYear, promoteStudents, recordStudentStatus } from "../../services/sisAcademicService";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../services/firebase";

export default function SchoolYearManager() {
  const user = getCurrentUser();
  const role = String(user?.role || "").toLowerCase();
  const isAdmin = role === "admin" || role === "superadmin";
  const [campus, setCampus] = useState(String(user?.campus || "gapan").toLowerCase());
  const [activeSY, setActiveSY] = useState("");
  const [calendarEmbedUrl, setCalendarEmbedUrl] = useState("");
  const [fromSY, setFromSY] = useState("");
  const [toSY, setToSY] = useState("");
  const [keepSection, setKeepSection] = useState(false);
  const [info, setInfo] = useState("");
  const [studentId, setStudentId] = useState("");
  const [statusType, setStatusType] = useState("withdraw");
  const [statusNote, setStatusNote] = useState("");

  useEffect(() => {
    (async () => {
      const settings = await getSISSettings(campus);
      const sy = settings?.schoolYear || "";
      setActiveSY(sy);
      setCalendarEmbedUrl(String(settings?.calendarEmbedUrl || ""));
      if (sy) setFromSY(sy);
      const now = new Date().getFullYear();
      const next = `${now}-${String((now + 1) % 100).padStart(2, "0")}`;
      setToSY(next);
    })();
  }, [campus]);

  async function saveActiveSY() {
    if (!activeSY) return;
    await setSISSettings(campus, { schoolYear: activeSY, calendarEmbedUrl: String(calendarEmbedUrl || "") });
    setInfo("SIS settings saved.");
  }

  async function doPromote() {
    setInfo("Promoting…");
    const count = await promoteStudents(campus, fromSY, toSY, { keepSection });
    setInfo(`Promoted ${count} students. Active School Year set to ${toSY}.`);
  }

  async function doStatus() {
    if (!studentId) return;
    const ok = await recordStudentStatus(studentId, { type: statusType, note: statusNote });
    setInfo(ok ? "Student status recorded." : "Student not found.");
  }

  async function countStudents() {
    const q = query(collection(db, "students"), where("campus", "==", campus));
    const snap = await getDocs(q);
    setInfo(`Students at ${campus.toUpperCase()}: ${snap.size}`);
  }

  return (
    <div className="container mt-4">
      <h3 className="mb-3">School Year Manager</h3>
      <div className="card p-3 mb-3">
        <div className="row g-2 align-items-end">
          {isAdmin && (
            <div className="col-md-3">
              <label className="form-label">Campus</label>
              <select className="form-select" value={campus} onChange={e => setCampus(e.target.value)}>
                <option value="gapan">Gapan</option>
                <option value="bulacan">Bulacan</option>
              </select>
            </div>
          )}
          <div className="col-md-3">
            <label className="form-label">Active School Year</label>
            <input className="form-control" placeholder="2026-27" value={activeSY} onChange={e => setActiveSY(e.target.value)} />
          </div>
          <div className="col-md-4">
            <label className="form-label">Calendar Embed URL</label>
            <input className="form-control" placeholder="https://docs.google.com/..." value={calendarEmbedUrl} onChange={e => setCalendarEmbedUrl(e.target.value)} />
          </div>
          <div className="col-md-2">
            <button className="btn btn-primary w-100" onClick={saveActiveSY}>Save</button>
          </div>
          <div className="col-md-2">
            <button className="btn btn-outline-secondary w-100" onClick={countStudents}>Count Students</button>
          </div>
        </div>
      </div>

      <div className="card p-3 mb-3">
        <h5 className="mb-3">End‑of‑Year Promotion</h5>
        <div className="row g-2">
          <div className="col-md-3">
            <label className="form-label">From SY</label>
            <input className="form-control" placeholder="2025-26" value={fromSY} onChange={e => setFromSY(e.target.value)} />
          </div>
          <div className="col-md-3">
            <label className="form-label">To SY</label>
            <input className="form-control" placeholder="2026-27" value={toSY} onChange={e => setToSY(e.target.value)} />
          </div>
          <div className="col-md-3 d-flex align-items-end">
            <div className="form-check">
              <input className="form-check-input" type="checkbox" id="keepSection" checked={keepSection} onChange={e => setKeepSection(e.target.checked)} />
              <label className="form-check-label" htmlFor="keepSection">Keep sections</label>
            </div>
          </div>
          <div className="col-md-3 d-flex align-items-end">
            <button className="btn btn-danger w-100" onClick={doPromote}>Promote Students</button>
          </div>
        </div>
      </div>

      <div className="card p-3">
        <h5 className="mb-3">Mid‑Year Transfer/Withdrawal</h5>
        <div className="row g-2">
          <div className="col-md-3">
            <label className="form-label">Student ID</label>
            <input className="form-control" value={studentId} onChange={e => setStudentId(e.target.value)} />
          </div>
          <div className="col-md-3">
            <label className="form-label">Action</label>
            <select className="form-select" value={statusType} onChange={e => setStatusType(e.target.value)}>
              <option value="withdraw">Withdraw</option>
              <option value="transfer">Transfer</option>
              <option value="return">Return to Active</option>
            </select>
          </div>
          <div className="col-md-4">
            <label className="form-label">Note</label>
            <input className="form-control" value={statusNote} onChange={e => setStatusNote(e.target.value)} />
          </div>
          <div className="col-md-2 d-flex align-items-end">
            <button className="btn btn-secondary w-100" onClick={doStatus}>Record</button>
          </div>
        </div>
      </div>

      {info && <div className="alert alert-info mt-3">{info}</div>}
    </div>
  );
}
